import { render } from "./AppIdiomSelect.vue?vue&type=template&id=32a67ae4"
import script from "./AppIdiomSelect.vue?vue&type=script&lang=ts"
export * from "./AppIdiomSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script